import React, { Suspense } from "react";
import { Accordion, AccordionItem } from "@commonComponents/accordion";
import { ActorDetailForm, ActorDetailHeader } from "@EUForms/parties";
import { partiesInfo } from "../../util/partiesLabel";
//import InputField from "@commonComponents/formComponents/CustomInputField";
import { Grid } from "semantic-ui-react";
import DropDown from '@commonComponents/formComponents/CustomDropDown';
import { FormTitle } from "@commonComponents/FormTitle";
//import SearchableDropdown from "@EUForms/searchableDropdown";
import RepeatableContainer from "@containers/repeatableContainer";
import { useSelector } from "react-redux";
import { selectRepresentationList } from "@EUForms/selectors";
const ActorDetail = React.lazy(() => import("./actorDetail"));

const PartiesContainer = ({ translate, isImportShipment, countryList, ...rest }) => {

  const partiesLabel = React.useMemo(() => partiesInfo(isImportShipment), [isImportShipment])
  //   const renderAtFirst=React.useCallback(({dataSource,onDropDownChange})=>{
  //     return(
  //      <Grid.Column>
  //        <SearchableDropdown
  //            id="unLoc"
  //           label="UNLOC"
  //           name="unlocode"
  //           dropdownType="unlocode"
  //           selectedValue={dataSource.unlocode}
  //           onSelect={({ value }) => onDropDownChange(value,"unlocode")}
  //           onBlur={({value})=>{
  //               if(!value){
  //                 onDropDownChange(value,"unlocode")
  //               }
  //           }}

  //         />

  //      </Grid.Column>
  //     )
  //  },[])

  //  const renderAtLast=React.useCallback(({dataSource,onBlurHandler,onChangeHandler})=>{
  //        if(!isImportShipment)
  //            return null
  //         return(
  // <>
  //          <Grid.Column>
  //          <InputField
  //                id="rexNo"
  //                name="rexNo"
  //                type='text'
  //                label="rex no."
  //                clearInput={false}
  //                value={dataSource.rexNo}
  //                onChange={onChangeHandler}
  //                onBlur={onBlurHandler}
  //                />
  //          </Grid.Column>
  //          <Grid.Column>
  //          <InputField
  //                id="originStat"
  //                name="originStat"
  //                type='text'
  //                label="origin stat."
  //                clearInput={false}
  //                value={dataSource.originStat}
  //                onChange={onChangeHandler}
  //                onBlur={onBlurHandler}
  //                />
  //          </Grid.Column>
  //         </>
  //         )
  //      },[isImportShipment])
  let representation = useSelector(state => state.actorReducer[partiesLabel.representative.tableName]?.[0]?.["representation"])
  const representationList = useSelector(selectRepresentationList)
  // representation=React.useMemo(()=>{
  //   return representationList?.find(c=>c.value==representation)?.text
  // },[representationList,representation])

  const renderAtLast = React.useCallback(
    ({ onDropDownChange }) => {


      return (
        <>
          <Grid.Column>
            <DropDown
              id={`Representation`}
              type='text'
              boxNumber='3/21'
              label='Representation'
              value={representation}
              text={representation}
              data={representationList}
              name='representation'
              onChange={onDropDownChange}
            />
          </Grid.Column>
        </>
      )
    },
    [representationList, representation]
  )

  const renderExporter = (id = "6") => {
    return (
      <AccordionItem id={id} title={(props) => (<ActorDetailHeader {...props} translate={translate} {...partiesLabel.exporter} ></ActorDetailHeader>)}>

        <RepeatableContainer
          maxRowsAllowed={1}
          {...rest}
          tableName={partiesLabel.exporter.tableName}
          actionType="PARTIES"
          reducerName="actorReducer"
          title=""
          translate={translate}
          renderForm={(params) => <ActorDetail
            {...params}
            renderForm={(props) => <ActorDetailForm countryList={countryList}    {...props} />}
          />
          }
        />
      </AccordionItem>
    )
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Accordion translate={translate}>
        <AccordionItem id="1" title={(props) => (
          <ActorDetailHeader {...props} translate={translate} {...partiesLabel.consignor} ></ActorDetailHeader>)}>
          <RepeatableContainer
            maxRowsAllowed={1}
            {...rest}
            tableName={partiesLabel.consignor.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title=""
            translate={translate}
            renderForm={(params) => <ActorDetail
              {...params}
              renderForm={(props) => <ActorDetailForm countryList={countryList} {...props} />}
            />
            }
          />

        </AccordionItem>
        {
          !isImportShipment && <>
            {renderExporter("5")}
          </>}
        <AccordionItem id="3" title={(props) => (<ActorDetailHeader {...props} translate={translate} {...partiesLabel.representative} ></ActorDetailHeader>)}>
          <RepeatableContainer
            maxRowsAllowed={1}
            {...rest}
            tableName={partiesLabel.representative.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title=""
            translate={translate}
            renderForm={(params) => <ActorDetail
              {...params}
              renderForm={(props) => <ActorDetailForm countryList={countryList} renderAtLast={renderAtLast}  {...props} />}
            />
            }
          />

        </AccordionItem>
        <AccordionItem id="2" title={(props) => (<ActorDetailHeader {...props} translate={translate}  {...partiesLabel.consignee} ></ActorDetailHeader>)}>
          <RepeatableContainer
            maxRowsAllowed={1}
            {...rest}
            tableName={partiesLabel.consignee.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title=""
            translate={translate}
            renderForm={(params) => <ActorDetail
              {...params}
              renderForm={(props) => <ActorDetailForm countryList={countryList}   {...props} />}
            />
            }
          />


        </AccordionItem>

        <AccordionItem id="4" title={(props) => (<ActorDetailHeader {...props} translate={translate} {...partiesLabel.declarant} ></ActorDetailHeader>)}>

          <RepeatableContainer
            maxRowsAllowed={1}
            {...rest}
            tableName={partiesLabel.declarant.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title=""
            translate={translate}
            renderForm={(params) => <ActorDetail
              {...params}
              renderForm={(props) => <ActorDetailForm countryList={countryList}   {...props} />}
            />
            }
          />

        </AccordionItem>


        {
          isImportShipment ? <>
            <AccordionItem id="5" title={(props) => (<ActorDetailHeader {...props} translate={translate} {...partiesLabel.importer} ></ActorDetailHeader>)}>
              <RepeatableContainer
                maxRowsAllowed={1}
                {...rest}
                tableName={partiesLabel.importer.tableName}
                actionType="PARTIES"
                reducerName="actorReducer"
                title=""
                translate={translate}
                renderForm={(params) => <ActorDetail
                  {...params}
                  renderForm={(props) => <ActorDetailForm countryList={countryList} {...props} />}
                />
                }
              />

            </AccordionItem>

            {renderExporter()}
            {!isImportShipment && (
              <AccordionItem id="7" title={(props) => (<ActorDetailHeader {...props} translate={translate} {...partiesLabel.forwarder} ></ActorDetailHeader>)}>
                <RepeatableContainer
                  maxRowsAllowed={1}
                  {...rest}
                  tableName={partiesLabel.forwarder.tableName}
                  actionType="PARTIES"
                  reducerName="actorReducer"
                  title=""
                  translate={translate}
                  renderForm={(params) => <ActorDetail
                    {...params}
                    renderForm={(props) => <ActorDetailForm countryList={countryList}   {...props} />}
                  />
                  }
                />
              </AccordionItem>
            )}
            <AccordionItem id="8" title={(props) => (<ActorDetailHeader {...props} translate={translate} {...partiesLabel.location} ></ActorDetailHeader>)}>
              <RepeatableContainer
                maxRowsAllowed={1}
                {...rest}
                tableName={partiesLabel.location.tableName}
                actionType="PARTIES"
                reducerName="actorReducer"
                title=""
                translate={translate}
                renderForm={(params) => <ActorDetail
                  {...params}
                  renderForm={(props) => <ActorDetailForm countryList={countryList}  {...props} />}
                />
                }
              />

            </AccordionItem>
            <AccordionItem id="9" title={(props) => (<ActorDetailHeader {...props} translate={translate} {...partiesLabel.buyer} ></ActorDetailHeader>)}>
              <RepeatableContainer
                maxRowsAllowed={1}
                {...rest}
                tableName={partiesLabel.buyer.tableName}
                actionType="PARTIES"
                reducerName="actorReducer"
                title=""
                translate={translate}
                renderForm={(params) => <ActorDetail
                  {...params}
                  renderForm={(props) => <ActorDetailForm countryList={countryList}  {...props} />}
                />
                }
              />

            </AccordionItem>
            <AccordionItem id="10" title={(props) => (<ActorDetailHeader {...props} translate={translate} {...partiesLabel.seller} ></ActorDetailHeader>)}>
              <RepeatableContainer
                maxRowsAllowed={1}
                {...rest}
                tableName={partiesLabel.seller.tableName}
                actionType="PARTIES"
                reducerName="actorReducer"
                title=""
                translate={translate}
                renderForm={(params) => <ActorDetail
                  {...params}
                  renderForm={(props) => <ActorDetailForm countryList={countryList}    {...props} />}
                />
                }
              />


            </AccordionItem>
            <AccordionItem id="11" title={(props) => (<ActorDetailHeader  {...props} translate={translate} {...partiesLabel.surety} ></ActorDetailHeader>)}>
              <RepeatableContainer
                maxRowsAllowed={1}
                {...rest}
                tableName={partiesLabel.surety.tableName}
                actionType="PARTIES"
                reducerName="actorReducer"
                title=""
                translate={translate}
                renderForm={(params) => <ActorDetail
                  {...params}
                  renderForm={(props) => <ActorDetailForm countryList={countryList}  {...props} />}
                />
                }
              />

            </AccordionItem>
          </>
            :
            <AccordionItem id="6" title={(props) => (<ActorDetailHeader  {...props} translate={translate} {...partiesLabel.carrier} ></ActorDetailHeader>)}>
              <RepeatableContainer
                maxRowsAllowed={1}
                {...rest}
                tableName={partiesLabel.carrier.tableName}
                actionType="PARTIES"
                reducerName="actorReducer"
                title=""
                translate={translate}
                renderForm={(params) => <ActorDetail
                  {...params}
                  renderForm={(props) => <ActorDetailForm countryList={countryList}   {...props} />}
                />
                }
              />

            </AccordionItem>

        }

      </Accordion>
    </Suspense>
  );
}

export default React.memo(PartiesContainer)
